module.exports = __webpack_public_path__ + "img/coinbase.ed315941.svg";